import { baseAPI } from "../baseApi"

export const panoramaApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение кадра панорамы
        fetchFrameInPoint: builder.query<any, any>({
            query: (args) => ({
                url: `video/findFrameByCoords?Longitude=${args.longitude}&Latitude=${args.latitude}&SearchTolerance=${args.tolerance}&Year=${args.year}&Season=${args.season}&DesiredDirection=%27${args.direction}%27`,
                responseHandler: ((response) => response.text()),
                cache: "no-cache",
            }),
        }),
        // запрос на получение следующего кадра
        fetchNextFrame: builder.query<any, any>({
            query: (args) => ({
                url: `video/findNextFrame?VideoPositionId=${args.positionID}&Direction=%27${args.direction}%27&HLookAngle=${args.hLookAngle}&VLookAngle=${args.vLookAngle}`,
                responseHandler: ((response) => response.text()),
                cache: "no-cache",
            }),
        }),
        // запрос на получение следующего кадра с большим шагом
        fetchFastNextFrame: builder.query<any, any>({
            query: (args) => ({
                url: `video/findFrameByPos?VideoDocumentId=${args.videoDocumentID}&SearchTolerance=${args.tolerance}&Pos=${args.videoKM}&HLookAngle=${args.hLookAngle}&VLookAngle=${args.vLookAngle}`,
                responseHandler: ((response) => response.text()),
                cache: "no-cache",
            }),
        }),
        // запрос на получение фильтров для панорамы
        fetchPanoramaFilters: builder.query<any, any>({
            query: (args) => ({
                url: `video-ext/getFilter?bbox=${args.bbox}&zoom=${args.zoom}`,
                responseHandler: ((response) => response.json()),
                cache: "no-cache",
            }),
        }),
    })
})

export const {
    useLazyFetchFastNextFrameQuery, useLazyFetchFrameInPointQuery, useLazyFetchNextFrameQuery, useLazyFetchPanoramaFiltersQuery
} = panoramaApiSlice


